import { fetcher } from '@commenda/utils';
import useSWR from 'swr';

import { BillingInvoiceHelper } from './billing-invoice-helper';
import type { TListInvoicesResponse, UseInvoicesOptions } from './types';

export function useInvoicesPage({ companyId, limit }: UseInvoicesOptions) {
  const query = new URLSearchParams({ companyId: String(companyId) });
  if (limit) query.set('limit', String(limit));
  const url = `${BillingInvoiceHelper.baseUrl(companyId)}/invoices?${query}`;

  return useSWR<TListInvoicesResponse>(companyId ? url : null, async () => {
    const res = await fetcher(url, { method: 'GET' });
    if (!res.ok) throw new Error('Could not load invoices.');
    return res.json();
  });
}
